import { ADD_EVENT_LISTENER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function addCallingEventListener(event) {
  return callingAPIMethodWithQueue(ADD_EVENT_LISTENER, event);
}